import { useState, useEffect } from "react";
import * as MuiIcons from "@mui/icons-material";
import api from "state/axios";
import { getIconComponent } from "scenes/CMS/menus/IconRegistry";


const DefaultIcon = MuiIcons["Label"];

const resolveIcon = (iconName) => {
    if (!iconName) return null;
    const resolved = getIconComponent(iconName);
    return resolved ?? (DefaultIcon ? <DefaultIcon /> : null);
};

const buildTree = (flatItems) => {
    const map = {};
    const roots = [];

    flatItems.forEach(item => {
        map[item._id] = {
            ...item,
            icon: resolveIcon(item.icon),
            subItems: [],
        };
    });

    flatItems.forEach(item => {
        // parent may be a populated object { _id, text } or a raw id string
        const parentId = item.parent?._id ?? item.parent ?? null;
        if (parentId) {
            map[parentId]?.subItems.push(map[item._id]);
        } else {
            roots.push(map[item._id]);
        }
    });

    const sort = (items) => {
        items.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        items.forEach(item => {
            if (item.subItems.length) {
                sort(item.subItems);
            } else {
                item.subItems = undefined;
            }
        });
        return items;
    };

    return sort(roots);
};

export const useMenus = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [items, setItems] = useState([]);


    useEffect(() => {    
        let cancelled = false;

        const fetchMenus = async () => {
            setLoading(true);
            try {
                const res = await api.get('/menus');
                if (!cancelled) {
                    setItems(buildTree(res.data));
                }
            } catch (err) {
                if (!cancelled) setError(err);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        fetchMenus();
        return () => { cancelled = true; };
    }, []);

    return { items, loading, error };
};
